import React from "react";
import { MenuItem } from "@mui/material";
import { useNavigate } from "react-router-dom";

interface UpdateProfileMenuItemProps {
  handleMenuClose: () => void;
  from: string;
  saveAndNavigateTo?: (path: string) => void;
  navigateToPath: string;
}

const UpdateProfileMenuItem: React.FC<UpdateProfileMenuItemProps> = ({
  handleMenuClose,
  from,
  saveAndNavigateTo,
  navigateToPath,
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    handleMenuClose();
    if (from === "dataViewer" && typeof saveAndNavigateTo === "function") {
      saveAndNavigateTo(navigateToPath);
    } else {
      navigate("/update-profile");
    }
  };

  return (
    <MenuItem onClick={handleClick} style={{ height: "35px", marginTop: "55px" }}>
      <div
        className="menuLink"
        style={{
          textDecoration: "none",
          color: "inherit",
          display: "flex",
          alignItems: "center",
        }}
      >
        <img
          src="/update.png"
          alt="Update Profile"
          style={{
            marginRight: "5px",
            width: "20px",
            height: "20px",
          }}
        />
        <span>Profile</span>
      </div>
    </MenuItem>
  );
};

export default UpdateProfileMenuItem;